// Vue
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Interfaces
import {IrisMessage} from '../../../interfaces/IrisMessage'

// Components
import {Message} from '../message/Message'

@Component({
    mixins: [template],
    components: {
        Message
    },
})
export class Iris extends Vue {

    @Prop({default: () => []})
    public messages!: IrisMessage[]

    @Prop({default: 'top-center'})
    public position!: string

    public created() {

    }

    public mounted() {
        
    }

    public destroyed() {

    }

    private get isActive() {
        return this.messages.length > 0;
    }

    private handleCloseMessage(id: string) {
        this.$emit('close', id)
    }
}
